import { useTranslations } from 'next-intl';

import HeartIcon from '@/fo/icons/base/icons/heart.svg';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitDrawerBase } from '@/fo/ui/kit/drawer/base';

import { styles } from './ClearCartModal.styles';

export interface ClearCartModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCartToWishlist: () => void;
  isLoading: boolean;
}

export function ClearCartModal({
  open,
  onOpenChange,
  onConfirm,
  onCartToWishlist,
  isLoading
}: ClearCartModalProps) {
  const slots = styles();

  const t = useTranslations();

  return (
    <UiKitDrawerBase
      contentClassName={slots.base()}
      title={t('clearCart')}
      open={open}
      onOpenChange={onOpenChange}
      direction="right"
      closeButtonClassName={slots.closeClearModal()}
    >
      <div className={slots.wrapper()}>
        <h3 className={slots.title()}>{t('clearCart')}?</h3>
        <p className={slots.description()}>{t('cart.clear.description')}</p>

        <div className={slots.buttons()}>
          <UiKitButtonBase
            color="secondary"
            onClick={onConfirm}
            disabled={isLoading}
            className={slots.button()}
          >
            {t('delete')}
          </UiKitButtonBase>

          <UiKitButtonBase
            onClick={onCartToWishlist}
            disabled={isLoading}
            className={slots.button()}
            childrenClassName={slots.wishlistButtonContent()}
          >
            {t('toWishlist')}
            <HeartIcon className={slots.icon()} />
          </UiKitButtonBase>
        </div>
      </div>
    </UiKitDrawerBase>
  );
}
